import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    useFetchQuestionBySubcatIds,
    useFetchQuestionsByIds,
} from "../../../../../../hooks/FetchQuestion";

import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import "../DashboardQuestionInterfaceStyles/DashboardQuestions.css";
import { setCurrentSubcategory, setUserAnswer, setMaxMarks, addSubQuestionData, clearSubQuestionData, setTraceToZero } from "../../../../../../redux/reducers/question_reducer";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import { getQuestionImageLink } from "../../../../../../api/auth";
export default function DashboardQuestions({
    onChecked,
    isSubmitted,
    isCorrect,
    getCorrectOptionId,
}) {
    const dispatch = useDispatch();
    const [showCheckboxes, setShowCheckboxes] = useState(false);
    const [showAnswer, setShowAnswer] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [revealButtonVisible, setRevealButtonVisible] = useState(true);
    const [textboxValue, setTextboxValue] = useState(""); // New state for textbox value
    const userId = useSelector((state) => state.auth.userId);
    const [image, setImage] = useState(null);


     const [childTextboxValues, setChildTextboxValues] = useState({});
    const [selectedChildOptions, setSelectedChildOptions] = useState({});
    const [showChildQuestions, setShowChildQuestions] = useState(false);
    const [currentChildIndex, setCurrentChildIndex] = useState(0);
    const [isSaveAllClicked, setIsSaveAllClicked] = useState(false);
    const [showChildAnswers, setShowChildAnswers] = useState(false);
    const [showParentAnswer, setShowParentAnswer] = useState(false);


    const selectedSubcategories = useSelector(
        (state) => state.selectedSubcategories
    );
    const selectedQuestionIds = useSelector(
        (state) => state.selectedQuestions.questions
    );



 
    

    const [excludedQuestions, setExcludedQuestions] = useState([]);

    const type = useSelector((state) => state.type.value);
    const questionExclusions = useSelector((state) => state.type.questionExclusions);
    const excludedIds = questionExclusions.length > 0 ? questionExclusions : [0];

    const didIComeFromResume = useSelector((state) => state.questions.gettingResultFromResume);




      const [buttonText, setButtonText] = useState(
    "Confirm Answer Here Before Submitting"
  );

    const [{ isLoading, apiData, serverError }] = useFetchQuestionBySubcatIds(
        selectedSubcategories,
        type,
        excludedIds
    );

    const questionObj = useSelector((state) => state.questions.queue[state.questions.trace]);



    const [checkedAnswers, setCheckedAnswers] = useState([]);
    const { trace } = useSelector((state) => state.questions);
    const result = useSelector((state) => state.result.result);
    

    
   

    useEffect(() => {
        const fetchImage = async () => {
            if (questionObj && questionObj.id) { // Ensure questionObj and id are defined
                const imageLink = await getQuestionImageLink(questionObj.id); // Await the image link
                setImage(imageLink.data.session[0].image); // Set the image after fetching
            }
        };

        fetchImage();
    }, [questionObj]); // Trigger only when questionObj changes // Trigger only when questionObj changes // Dependencies, in this case, questionObj.id

    //console.log("LOOK AT ME", image);
    //const image = 'https://preclinique-my.sharepoint.com/personal/rchoudhary_preclinique_co_uk/Documents/Question%20Bank%20Images/1.5%20Cholesterol.jpg';


    function onSelect(optionId, index) {
        onChecked(questionObj.id, optionId);
        let newCheckedAnswers = [...checkedAnswers];
        newCheckedAnswers[trace] = index;
        setCheckedAnswers(newCheckedAnswers);
    }

    const handleRevealButtonClick = () => {
        setShowCheckboxes(true);
        setShowAnswer(true);
        setRevealButtonVisible(false);
    };

    const handleOptionChange = (e) => {
        const selectedValue = e.target.value;
        let selectedOptionId;
        if (selectedValue === "correct") {
            const correctOption = questionObj.options.find(
                (option) => option.is_correct
            );
            selectedOptionId = correctOption ? correctOption.option_id : null;
        } else if (selectedValue === "incorrect") {
            selectedOptionId = "1";
        }
        setSelectedOption(selectedValue); // Update selectedOption state
        onChecked(questionObj.id, selectedOptionId);
    };

    useEffect(() => {
        setRevealButtonVisible(true);
        setShowCheckboxes(false);
        setShowAnswer(false);
        setTextboxValue(""); // Reset textbox value to its placeholder
        setSelectedOption(""); // Reset selectedOption to empty string to uncheck radio buttons
    }, [trace]); // Triggered when `trace` changes

    function renderControl(i, option) {
        if (isSubmitted[trace]) {
            if (checkedAnswers[trace] === i) {
                return isCorrect[trace] ? (
                    <div
                        style={{
                            padding: "8px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <CheckCircleOutlineIcon color="primary" />
                    </div>
                ) : (
                    <div
                        style={{
                            padding: "8px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <HighlightOffIcon color="error" />
                    </div>
                );
            }
            if (getCorrectOptionId(questionObj.id) === option.option_id) {
                return (
                    <div
                        style={{
                            padding: "8px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <CheckCircleOutlineIcon color="primary" />
                    </div>
                );
            }
        }
        return (
            <>
                <Radio
                    checked={checkedAnswers[trace] === i}
                    onChange={() => onSelect(option.option_id, i)}
                    name="options"
                    color="primary"
                    disabled={isSubmitted[trace]}
                />
            </>
        );
    }

    function getOptionClass(i, option) {
        if (isSubmitted[trace]) {
            if (checkedAnswers[trace] === i) {
                return isCorrect[trace] ? "correct-answer" : "incorrect-answer";
            }
            if (getCorrectOptionId(questionObj.id) === option.option_id) {
                return "correct-answer";
            }
        }
        return "";
    }

    if (isLoading) return <h3 className="text-light">Loading...</h3>;
    if (serverError)
        return <h3 className="text-light">{serverError || "Unknown Error"}</h3>;

    if (!questionObj) {
        return <div>Loading...</div>;
    }

    return (
    <div className="questions">
        {questionObj.type === 1 && (
            <>
                <h2 className="question-text">{questionObj?.question}</h2>
                {image ? <img src={image} alt="Question Related" style={{ maxWidth: "100%", height: "auto" }} /> : null}
                <FormGroup role="radiogroup">
                    {questionObj?.options
                        .filter((option) => option.option_id !== 9999) // Filter out option_id 9999
                        .map((option, i) => (
                            <div key={option.option_id} className={`option-border-style ${getOptionClass(i, option)}`}>
                                <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                                    <FormControlLabel
                                        value={option.option_id}
                                        control={renderControl(i, option)}
                                        label={option.option_text}
                                        className="question-option-label"
                                    />
                                </div>
                                <Collapse in={isSubmitted[trace]} timeout="auto" unmountOnExit>
                                    <div className="explanation-style">{option?.explanation_text}</div>
                                </Collapse>
                            </div>
                        ))}
                </FormGroup>
            </>
        )}

         {questionObj.type === 2 && (
            <div>
                <h2 className="question-text">{questionObj?.question}</h2>
                {image ? <img src={image} alt="Question Related" style={{ maxWidth: "100%", height: "auto" }} /> : null}
                <div>
                    <input
                        type="text"
                        placeholder="Enter your answer"
                        className="fancy-text-input"
                        value={textboxValue}
                        onChange={(e) => {
                            setTextboxValue(e.target.value);
                            dispatch(setUserAnswer(e.target.value));
                        }}
                    />
                    {revealButtonVisible && (
                        <button className="reveal-button" onClick={handleRevealButtonClick}>
                            Reveal Answer
                        </button>
                    )}
                    {showCheckboxes && (
                        <div className="checkbox-container">
                            <div>
                                <input
                                    type="radio"
                                    id="correct"
                                    name="answer"
                                    value="correct"
                                    checked={selectedOption === "correct"}
                                    onChange={handleOptionChange}
                                    className="checkbox-input"
                                />
                                <label htmlFor="correct" className="checkbox-label">
                                    Correct
                                </label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id="incorrect"
                                    name="answer"
                                    value="incorrect"
                                    checked={selectedOption === "incorrect"}
                                    onChange={handleOptionChange}
                                    className="checkbox-input"
                                />
                                <label htmlFor="incorrect" className="checkbox-label">
                                    Incorrect
                                </label>
                            </div>
                        </div>
                    )}
                </div>
                {showAnswer && (
                    <div>
                        Correct Answer:
                        {questionObj.options
                            .filter((option) => option.option_id !== 9999) // Filter here as well
                            .map(
                                (option) => option.is_correct && <div key={option.option_id}>{option.option_text}</div>
                            )}
                    </div>
                )}
            </div>


        )}
         {/* Type 3 Questions */}
{questionObj.type === 3 && (
    <div>
        {/* Render the parent question */}
        <h2 className="question-text">{questionObj?.question}</h2>
        <div>
            {image ? (
                <img src={image} alt=" " style={{ maxWidth: "100%", height: "auto" }} />
            ) : null}
        </div>

        {/* Parent question textbox (always visible) */}
        <div>
            <input
                type="text"
                placeholder="Enter your answer"
                className="fancy-text-input"
                value={textboxValue}
                onChange={(e) => {
                    setTextboxValue(e.target.value);
                    dispatch(setUserAnswer(e.target.value));
                }}
            />
            
            {showParentAnswer && questionObj.options && (
                <div className="correct-answer">
                    <strong>Correct Answer:</strong>{" "}
                    {
                        questionObj.options.find((opt) => opt.is_correct)?.option_text ||
                        "Not available"
                    }
                </div>
            )}
        </div>

        {/* Parent confirm button (only visible before child questions are shown) */}
        {!showChildQuestions && (
            <button
                className="reveal-button"
                onClick={() => {
                    dispatch(setUserAnswer(textboxValue));
                    setShowChildQuestions(true);
                    setShowParentAnswer(true);
                    setButtonText('Answer Saved... Please Proceed To Next Part');
                    setTimeout(() => {
                        setButtonText('Confirm Answer Here Before Submitting');
                    }, 3000);
                }}
            >
                {buttonText}
            </button>
        )}

        {/* Render child questions incrementally */}
        {showChildQuestions && questionObj.child_question_ids && (
            <div className="child-questions-container">
                {/* Show all child questions up to the current index */}
                {questionObj.child_question_ids
                    .slice(0, currentChildIndex + 1)
                    .map((childQuestion, index) => (
                        <div key={index} className="child-question">
                            <h3 className="child-question-text">
                                {childQuestion.question_b_text || childQuestion.question_c_text || childQuestion.question_d_text || childQuestion.question_e_text || childQuestion.question_f_text || childQuestion.question_g_text || childQuestion.question_h_text || childQuestion.question_i_text}
                            </h3>
                            <div>
                                {childQuestion.image && (
                                    <img
                                        src={childQuestion.image}
                                        alt=""
                                        style={{ maxWidth: "100%", height: "auto" }}
                                    />
                                )}
                            </div>

                            {/* Textbox for the current child question */}
                            <input
                                type="text"
                                placeholder="Enter your answer"
                                className="fancy-text-input"
                                value={childTextboxValues[index] || ""}
                                onChange={(e) =>
                                    setChildTextboxValues({
                                        ...childTextboxValues,
                                        [index]: e.target.value,
                                    })
                                }
                                disabled={index < currentChildIndex} // Disable previous questions
                            />
                            
                            {/* Show correct answer immediately after confirming this question */}
                            {(index < currentChildIndex || isSaveAllClicked) && childQuestion.correct_answer && (
                                <div className="correct-answer">
                                    <strong>Correct Answer:</strong> {childQuestion.correct_answer}
                                </div>
                            )}

                            {/* Confirm button for each question except the last one */}
                            {index === currentChildIndex && (
                                <button
                                    className="reveal-button"
                                    onClick={() => {
                                        // Save the current answer
                                        const userAnswer = childTextboxValues[index];
                                        if (userAnswer) {
                                            const subQuestionData = {
                                                question_b_text: childQuestion.question_b_text || childQuestion.question_c_text || childQuestion.question_d_text || childQuestion.question_e_text || childQuestion.question_f_text || childQuestion.question_g_text || childQuestion.question_h_text || childQuestion.question_i_text,
                                                user_answer: userAnswer,
                                                is_correct: childQuestion.correct_answer,
                                            };
                                            dispatch(addSubQuestionData(subQuestionData));
                                        }

                                        // Move to next question or show final options
                                        if (currentChildIndex < questionObj.child_question_ids.length - 1) {
                                            setCurrentChildIndex(currentChildIndex + 1);
                                        } else {
                                            setIsSaveAllClicked(true);
                                        }
                                    }}
                                    disabled={!childTextboxValues[index]} // Disable if no answer
                                >
                                    {currentChildIndex < questionObj.child_question_ids.length - 1 
                                        ? "Confirm Answer Here Before Submitting"
                                        : "Submit Final Answer Then Mark Below"}
                                </button>
                            )}
                        </div>
                    ))}

                {/* Final radio buttons only appear after all questions are answered */}
                {isSaveAllClicked && (
                    <div className="checkbox-container">
                        <div>
                            <input
                                type="radio"
                                id="correct-final"
                                name="answer-final"
                                value="correct"
                                checked={selectedOption === "correct"}
                                onChange={(e) => {
                                    setSelectedOption(e.target.value);
                                    onChecked(questionObj.id, "correct");
                                }}
                                className="checkbox-input"
                            />
                            <label htmlFor="correct-final" className="checkbox-label">
                                Correct
                            </label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="incorrect-final"
                                name="answer-final"
                                value="incorrect"
                                checked={selectedOption === "incorrect"}
                                onChange={(e) => {
                                    setSelectedOption(e.target.value);
                                    onChecked(questionObj.id, "incorrect");
                                }}
                                className="checkbox-input"
                            />
                            <label htmlFor="incorrect-final" className="checkbox-label">
                                Incorrect
                            </label>
                        </div>
                    </div>
                )}
            </div>
        )}
    </div>
)}

        {isSubmitted[trace] && questionObj.lectureReference && (
            <div className="lecture-reference">
                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ fontStyle: "italic" }}
                >
                    Refer to: {questionObj.lectureReference}
                </Typography>
            </div>
        )}
    </div>
);
}
